import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import { getLoginRoute, publicRoutes } from '../common/routes';
import {
  useEnvironmentServiceContext,
  useIntercomStoreContext,
} from '../common/v2/context/contexts';

export const PublicRoutes = memo(() => {
  console.log2('PublicRoutes start');
  const intercomStore = useIntercomStoreContext();
  const environmentService = useEnvironmentServiceContext();
  const loginRoute = getLoginRoute(environmentService);
  return (
    <Switch>
      {publicRoutes.map((route, i) => {
        console.log2('PublicRoute route', route);
        return <Route key={i} component={route.comp()} {...route} />;
      })}
      <Route key={'login'} component={loginRoute} />
    </Switch>
  );
});
PublicRoutes.displayName = 'PublicRoutes';
